<template>

    <!-- ここから -->
    <div class="wrap _full">
        <div class="inner">

            <!-- この見出しは不要 -->
            <h2 class="heading_component"><span>ブランド_トーク画面</span></h2>
            <div class="comment">
                <p>横幅100％で表示したいので一旦全体コンテンツの .wrap を解除しています。</p>
                <p>この見出しを除いた3行目からコピペすればいけます。</p>
                <p>1. ファイルをクリアする挙動は未実装です。</p>
                <p>2. ファイル名を表示させるための 190行目~のスクリプトが必要です。</p>
            </div>
            <!-- /この見出しは不要 -->

            <section>

                <div class="talk_component">
                    <div class="wrap">
                        <div class="talk-inner">

                            <!--:::::::::::::::::::::::::::::::::::::::::::::::

                                BubbleArea

                            :::::::::::::::::::::::::::::::::::::::::::::::::-->

                            <!-- Bubble -->
                            <div class="bubble-item">
                                <div class="avatar-wrap">
                                    <img src="/img/smp/end-user-shop1.jpg" alt="" class="avatar">
                                </div>
                                <div class="bubble-wrap">
                                    <div class="bubble-body">
                                        <p><span>ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。</span></p>
                                    </div>
                                    <time>2022/12/12 18:00</time>
                                </div>
                            </div>

                            <!-- Bubble -->
                            <div class="bubble-item _my-bubble">
                                <div class="avatar-wrap">
                                    <img src="/img/smp/avatar.jpg" alt="" class="avatar">
                                </div>
                                <div class="bubble-wrap">
                                    <div class="bubble-body">
                                        <p><span>ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。</span></p>
                                    </div>
                                    <time>2022/12/12 18:00</time>
                                </div>
                            </div>

                            <!-- Bubble -->
                            <div class="bubble-item">
                                <div class="avatar-wrap">
                                    <img src="/img/smp/end-user-shop1.jpg" alt="" class="avatar">
                                </div>
                                <div class="bubble-wrap">
                                    <div class="bubble-body">
                                        <p><span>ダミーテキストです。</span></p>
                                    </div>
                                    <time>2022/12/12 18:00</time>
                                </div>
                            </div>

                            <!-- Bubble -->
                            <div class="bubble-item _my-bubble">
                                <div class="avatar-wrap">
                                    <img src="/img/smp/avatar.jpg" alt="" class="avatar">
                                </div>
                                <div class="bubble-wrap">
                                    <div class="bubble-body">
                                        <p><span>ダミーテキストです。ダミーテキストです。ダミーテキストです。ダミーテキストです。</span></p>
                                    </div>
                                    <time>2022/12/12 18:00</time>
                                </div>
                            </div>

                            <!-- Bubble -->
                            <div class="bubble-item _my-bubble">
                                <div class="avatar-wrap">
                                    <img src="/img/smp/avatar.jpg" alt="" class="avatar">
                                </div>
                                <div class="bubble-wrap">
                                    <div class="bubble-body">
                                        <p><span>ダミーテキストです。ダミーテキストです。</span></p>
                                    </div>
                                    <time>2022/12/12 18:00</time>
                                </div>
                            </div>

                            <!--:::::::::::::::::::::::::::::::::::::::::::::::

                                /BubbleArea

                            :::::::::::::::::::::::::::::::::::::::::::::::::-->

                        </div><!-- /Inner -->

                        <!-- Control -->
                        <div class="control-wrap">

                            <!-- 2025 追加ここから -->
                            <div class="fab-wrap">
                                <div>
                                    <button class="fab _back">
                                        <div class="md_svg-icon">
                                            <SvgIconBack />
                                        </div>
                                    </button>
                                </div>
                                <div>
                                    <p><span>運営に報告する</span></p>
                                    <button class="fab">
                                        <div class="md_svg-icon _white">
                                            <SvgIconExclamation />
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <!-- 2025 追加ここまで -->

                            <div class="input-wrap">
                                <div class="talk-inner">
                                    <div class="input-row">
                                        <!-- 0225追加 ここから -->
                                        <!-- 1. ファイルをクリアする挙動は未実装です。 -->
                                        <!-- 2. ファイル名を表示させるための 190行目~のスクリプトが必要です。 -->
                                        <label for="talk-files1" class="_add btn_svg-icon">
                                            <SvgIconAdd />
                                        </label>
                                        <div class="file-name js-upload-filename"></div>
                                        <div class="file-name-bubble"></div>
                                        <div class="file-clear btn_svg-icon _white">
                                            <SvgIconCancel />
                                        </div>
                                        <input type="file" id="talk-files1" name="talk-files" class="js-upload-file">
                                        <!-- 0225追加 ここまで -->
                                        <textarea maxlength="250" name="" id=""></textarea>
                                        <button><span>SEND</span></button>
                                    </div>
                                </div>
                            </div>

                        </div><!-- /Control -->

                    </div><!-- /Wrap -->
                </div><!-- /TalkComponent -->

            </section>

        </div><!--/.ly_main .inner-->
    </div><!--/.ly_main .wrap-->

    <!-- ここまで -->

</template>

<script>
    //ScrollTrigger
    import gsap from 'gsap';
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger);

    //Svg
    import SvgIconExclamation from '@/components/EndUser/svg/SvgIconExclamation'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            //Svg
            SvgIconExclamation,
            SvgIconCancel,
            SvgIconBack,
            SvgIconAdd
        },
        mounted() {

            ////////////////////////////////////
            // ページが読み込まれたら ScrollTrigger.js の トリガー位置を再計算する
            ////////////////////////////////////
            window: onload = function () {
                ScrollTrigger.refresh(true);
            },

            ////////////////////////////////////
            // 発言入力エリアを部分的に固定する
            ////////////////////////////////////
            ScrollTrigger.create({
                trigger: ".talk_component .control-wrap",
                start: "bottom 100%",
                endTrigger: ".talk_component",
                end: "bottom 100%",
                pin: true,
                pinSpacing: false,
            });

            ////////////////////////////////////
            // 02/25 追加 ファイル名を表示させる
            ////////////////////////////////////
            $('.js-upload-file').on('change', function () { //ファイルが選択されたら
                var file = $(this).prop('files')[0]; //ファイルの情報を代入(file.name=ファイル名/file.size=ファイルサイズ/file.type=ファイルタイプ)
                $('.js-upload-filename').text(file.name); //ファイル名を出力
            });

        }
    };

</script>
